// store.js

import { createStore } from "redux";
import stepReducer from "./stepSlice";

const store = createStore(stepReducer);

export default store;
